module.exports = __webpack_public_path__ + "img/img-top.3ab7d9fd.png";